<template>
  <div class="typeArea">
    <div class="top">
        <div class="top-left">
            <div class="slogn">
                <div>健安德致力于</div>
                <div>为了更健康的世界</div>
            </div>
            <!-- <defaultImg :src="require('@/assets/images/image43.png')"></defaultImg> -->
        </div>
        <div class="top-right">
            <div class="top-right-line1">
                <img src="@/assets/images/image44.png" alt="">
                <span>健安德服务热线</span>
            </div>
            <div class="top-right-line2">0851-84439909</div>
            <div class="top-right-line3">
                <div class="top-right-line3-item">
                    <div>
                        <img src="@/assets/images/image45.png" alt="">
                        <span>电子邮箱</span>
                    </div>
                    <div>jiandee@jiandee.com</div>
                </div>
                <div class="top-right-line3-item">
                    <div>
                        <img src="@/assets/images/image46.png" alt="">
                        <span>健安德投诉电话</span>
                    </div>
                    <div>199 8561 5652</div>
                </div>
            </div>
            <div class="top-right-line4">
                <div>
                    <img src="@/assets/images/image47.png" alt="">
                    <span>联系地址</span>
                </div>
                <div>贵州省贵阳市国家高新区白金大道3491号贵州科学城14#楼</div>
            </div>
        </div>
    </div>
    <div class="bottom">
        <el-amap style="width: 100%;height: 500px;margin: 80px 0;" vid="amapDemo" :zoom="16" :center="center">
            <el-amap-marker :position="center"><img src="@/assets/images/zb.png"></el-amap-marker>
        </el-amap>
    </div>
  </div>
</template>

<script>
export default {
  name: 'contactUs',
  data () {
    return {
        center:[106.657681,26.721572]
    }
  },
  methods: {},
}
</script> 

<style lang='less' scoped>
    .top{
        overflow: hidden;
        .top-left{
            float: left;
            .slogn{
                font-weight: bold;
                font-size: 48px;
                letter-spacing: 2px;
                &>div:last-child{
                    margin-top: 3px;
                }
            }
            img{
                margin-top: 95px;
                cursor: pointer;
            }
        }
        .top-right{
            float: right;
            width: 500px;
            padding-top: 10px;
            font-size: 14px;
            color: #3D3D3D;
            .top-right-line1{
                display: flex;
                align-items: center;
                img{
                    margin-right: 10px;
                }
            }
            .top-right-line2{
                color: #DB0000;
                font-size: 54px;
                font-weight: bold;
                margin-top: 10px;
            }
            .top-right-line3{
                display: flex;
                justify-content: space-between;
                margin-top: 20px;
                .top-right-line3-item{
                    &>div:first-child{
                        display: flex;
                        align-items: center;
                        img{
                            margin-right: 10px;
                        }
                    }
                    &>div:last-child{
                        font-size: 18px;
                        margin-top: 7px;
                    }
                }
            }
            .top-right-line4{
                margin-top: 35px;
                &>div:first-child{
                    display: flex;
                    align-items: center;
                    img{
                        margin-right: 10px;
                    }
                }
                &>div:last-child{
                    font-size: 18px;
                    margin-top: 7px;
                }
            }
        }
    }
    .bottom{

    }
</style>
